import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SurveyType } from 'shared/services/prisma/types';
import globalMessages from 'translations/messages';

const SurveyTypePluralLabel = ({ type }) => {
  let message;

  switch (type) {
    case SurveyType.General:
      message = globalMessages.generalSurveys;
      break;
    case SurveyType.Feedback:
      message = globalMessages.feedback;
      break;
    case SurveyType.Targeted:
      message = globalMessages.targetedSurveys;
      break;
    case SurveyType.Cx:
      message = globalMessages.cxSurveys;
      break;
    default:
  }

  if (message) {
    return <FormattedMessage {...message} />;
  }

  return null;
};

export default SurveyTypePluralLabel;
